<template>
  <div class="animated fadeIn">
    <div>
      <modal name="modal-order_export" height="auto" :adaptive="true">
        <div class="m-3 p-3">
          <div class="p-2">
            <div>
              <div class="form-group">
                <label class="font-weight-bold">Select Date Range:</label>
              </div>

              <div class="form-group">
                <label class="font-weight-bold">Select Date Type:</label>
                <select class="form-control" v-model="date_type">
                  <option selected value="schedule" v-if="service !== '2'"
                    >Scheduled</option
                  >
                  <option value="created_at">Created at</option>
                </select>
              </div>
              <div class="form-group">
                <label class="font-weight-bold">Select Status:</label>
                <select class="form-control" v-model="status">
                  <option selected value="all">All</option>
                  <option value="pending">Pending</option>
                  <option value="accepted">Accepted</option>
                  <option value="started">Started</option>
                  <option value="completed">Completed</option>
                  <option value="rejected">Rejected</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
              <button
                @click="closeModal"
                class="btn btn-danger float-right m-1"
              >
                Cancel
              </button>
              <button
                @click="ExportOrder"
                class="btn btn-romoni-secondary float-right m-1"
              >
                Export Order Report
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
    <div>
      <div>
        <div>
          <div class="d-flex">
            <div style="margin-left: auto;" class="mb-3">
              <span class="mx-1">Per Page: </span>
              <select
                class="form-control"
                v-model="perPageItem"
                @change="makeReadySearchParams()"
              >
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </select>
            </div>
          </div>
          <div class="table-responsive" id="order_table_container">
            <table style="width: 100%;">
              <tr class="hadingOne">
                <th
                  v-for="item in columns"
                  :key="item"
                  @click="headingSortColumn(item)"
                >
                  <div class="d-flex justify-content-between">
                    <span class="mr-2"> {{ makeColNameReadable(item) }} </span>
                    <span
                      :class="getSortIconStyle(item)"
                      class="d-flex align-items-center"
                    ></span>
                  </div>
                </th>
              </tr>
              <tr>
                <th v-for="item in columns" :key="item">
                  <div v-if="dateColumns.includes(item)">
                    <span
                      v-html="makeDateRangeStrReadable(dateRangeString[item])"
                    ></span>
                  </div>
                  <div v-else-if="noFilteColumns.includes(item)"></div>
                  <div v-else>
                    <input
                      v-model="columnInputs[item]"
                      :name="item"
                      class="form-control"
                      :placeholder="`Filter By ${item}`"
                      @keyup="handleInputChange"
                    />
                  </div>
                </th>
              </tr>

              <tr v-for="order in orders" :key="order.id">
                <td>{{ order.created_at }}</td>
                <td>{{ order.id }}</td>
                <td>{{ order.phone }}</td>
                <td>{{ order.otp }}</td>
              </tr>
            </table>

            <div class="pl-1 my-3">
              <span>{{ total_count }} records </span>
            </div>
          </div>
        </div>
        <paginate
          :pageCount="totalPageCount"
          :clickHandler="onPaginateClick"
          :prevText="'Prev'"
          :nextText="'Next'"
          :container-class="'pagination otp-pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import paginate from "vuejs-paginate";
import _ from "lodash";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
let typingTimer;
const Admin_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "Orders",
  components: {
    paginate,
  },
  data() {
    return {
      orders: [],
      total_count: "0",
      date_from: "",
      date_to: "",
      date_type: "schedule",
      service: "all",
      category: "all",
      categories: [],
      status: "all",
      exporting: false,

      totalPageCount: 0,
      perPageItem: 10, // Only set this value
      pageNumber: 0,

      toSortColumn: "",
      sortingDirection: "",
      columns: ["created_at", "id", "phone", "otp"],
      columnInputs: {},
      dateColumns: ["created_at", "scheduled_date"],
      noFilteColumns: ["action"],

      dateRange: {
        created_at: "",
        scheduled_date: "",
      },
      dateRangeString: {
        created_at: "",
        scheduled_date: "",
      },
    };
  },
  created() {
    this.makeReadySearchParams();
  },
  computed: {
    getStyleOfStatus: function() {
      return (parm) => {
        if (parm === "pending") {
          return "badge badge-primary";
        } else if (parm === "accepted") {
          return "badge badge-warning";
        } else if (parm === "started") {
          return "badge badge-secondary";
        } else if (parm === "completed") {
          return "badge badge-success";
        } else if (parm === "rejected") {
          return "badge badge-danger";
        } else if (parm === "cancelled") {
          return "badge badge-dark";
        } else {
          return "";
        }
      };
    },
    getSortIconStyle: function() {
      return (parm) => {
        const defaultIcon = "fa fa-sort";
        if (parm === this.toSortColumn) {
          return `${defaultIcon}${this.sortingDirection}`;
        }
        return `${defaultIcon}`;
      };
    },
    makeDateRangeStrReadable: function() {
      return (name) => {
        if (name === null || name === undefined || name === "") {
          return name;
        }
        return name;
        let res = name.split("-");
        return res[0] + "<br> - <br>" + res[1];
      };
    },
    makeColNameReadable: function() {
      return (colName) => {
        const splitedWords = colName.split("_");
        for (let index in splitedWords) {
          splitedWords[index] =
            splitedWords[index].charAt(0).toUpperCase() +
            splitedWords[index].slice(1);
        }
        const readableName = splitedWords.join(" "); // splited by _ then join them.
        return readableName.replace(/([a-z0-9])([A-Z])/g, "$1 $2"); // even to split the camelcase
      };
    },
  },
  methods: {
    modalExport() {
      this.$modal.show("modal-order_export");
    },
    closeModal() {
      this.$modal.hide("modal-order_export");
    },
    ExportOrder() {
      this.exporting = true;
      axios({
        method: "post",
        url: `${Admin_URL}/otp`,
        responseType: "blob",
        data: {
          service: this.service,
          category: this.category,
          date_type: this.date_type,
          status: this.status,
          date_from: this.date_from,
          date_to: this.date_to,
        },
      })
        .then((response) => {
          console.log(response.data);
          this.exporting = false;

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "order_report_" +
              moment(this.date_from).format("YYYY-MM-DD") +
              "~" +
              moment(this.date_to).format("YYYY-MM-DD") +
              ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          this.$swal("Report Exported Successfully", "", "success");
          this.closeModal();
        })
        .catch((e) => {
          console.log("error occurs", e);
        });

      if (this.service === "2") {
        this.date_type = "created_at";
      }
    },
    fetchCategories() {
      axios
        .post(`${Admin_URL}/categories`, {
          service_id: this.service,
        })
        .then((response) => {
          this.categories = response.data;
        })
        .catch((e) => {
          console.log("error occurs");
        });

      if (this.service === "2") {
        this.date_type = "created_at";
      }
    },
    createOrder(type) {
      if (type !== "Beauty Appointment") {
        this.$router.push({ name: "OrderCreate", params: { type } });
      } else {
        this.$router.push({ name: "AppointmentCreate", params: { type } });
      }
      console.log(type);
    },
    handleDateRangeChange(colName) {
      // console.log(
      //     '\ncolName === ', colName,
      //     '\ndateRange === ', this.dateRange,
      //     '\n333333', this.dateRange[colName]
      //     );

      if (this.dateRange[colName] === "" || this.dateRange[colName] === null) {
        this.dateRangeString[colName] = "";
      } else {
        const startDate = this.dateRange[colName].start;
        const endDate = this.dateRange[colName].end;

        const startMoment = moment(startDate).format("MMM Do YY");
        const endMoment =
          endDate === null || endDate === ""
            ? "Select End Date"
            : moment(endDate).format("MMM Do YY");
        this.dateRangeString[colName] = startMoment + "-" + endMoment;
      }
      this.makeReadySearchParams();
      console.log("Seeeeee   ", this.dateRange, "EEEEE", this.dateRangeString);
    },
    headingSortColumn(colName) {
      // console.log('heading Click ', colName);
      if (this.toSortColumn === colName) {
        if (this.sortingDirection === "") {
          this.sortingDirection = "-up";
        } else {
          this.sortingDirection =
            this.sortingDirection === "-up" ? "-down" : "-up";
        }
      } else {
        this.sortingDirection = "-up";
      }
      this.toSortColumn = colName;
      const copyArray = [...this.orders];

      let sortByColumn = colName;
      if (colName === "action") {
        sortByColumn = "id";
      }
      if (this.sortingDirection === "-up") {
        this.orders = _.orderBy(copyArray, [sortByColumn], ["asc"]);
      } else {
        this.orders = _.orderBy(copyArray, [sortByColumn], ["desc"]);
      }
    },
    handleInputChange(e) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        this.makeReadySearchParams();
      }, 500);
    },
    makeReadySearchParams() {
      const id = this.getInputValue("id");
      const phone = this.getInputValue("phone");
      const otp = this.getInputValue("otp");
      const pageNumber = this.pageNumber;

      let setStatusCom = 1;

      const statusCompleted = setStatusCom;
      //console.log( "Shipping_Phone ", shipping_phone, typeof( this.dateRange.created_at));

      const srcParams = {
        id,
        phone,
        otp,
        page: pageNumber,
      };

      this.fetchOrder(srcParams);
      console.log("search ---- parms ---- ", srcParams);
    },
    getInputValue(colName) {
      if (this.columnInputs[colName] === undefined) {
        return "";
      }
      return this.columnInputs[colName];
    },
    fetchOrder(srcParms) {
      axios
        .get(`${Admin_URL}/otp`, {
          params: srcParms,
        })
        .then((response) => {
          console.log("fetchOrder:: response data ===== ", response.data);
          this.orders = response.data.data;
          console.log("--order", this.orders);
          this.totalPageCount = response.data.last_page;
          this.total_count = response.data.total;
        })
        .catch((e) => {
          // console.log("error occurs", e.response);
        });
    },
    onPaginateClick(parm) {
      this.pageNumber = parm - 1; // As api start from "pageNumber 0"
      this.makeReadySearchParams();
    },
  },
};
</script>
<style scoped lang="css">
.vdp-datepicker {
  display: inline-block;
  margin-right: 1rem;
}
.form-control {
  border: 1px solid #a9a9a9;
}
table,
th,
td {
  border: 1px solid #c4c4b7;
  border-collapse: collapse;
}
th,
td {
  padding: 15px;
  text-align: left;
}
table#t01 {
  width: 100%;
  background-color: #f1f1c1;
}
th {
  border-bottom-width: 2px;
  border-bottom-color: #c4c4b7;
}

#order_table_container {
  min-height: 600px;
}
.badge {
  font-size: 0.75rem;
}
.glow {
  /*animation: blinker 1s linear infinite;*/
  -webkit-animation: glowing 1500ms infinite;
  -moz-animation: glowing 1500ms infinite;
  -o-animation: glowing 1500ms infinite;
  animation: glowing 1500ms infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
@-webkit-keyframes glowing {
  0% {
    background-color: #b20000;
    -webkit-box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    -webkit-box-shadow: 0 0 40px #ff0000;
  }
  100% {
    background-color: #b2295a;
    -webkit-box-shadow: 0 0 3px #b24b71;
  }
}

@-moz-keyframes glowing {
  0% {
    background-color: #b20000;
    -moz-box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    -moz-box-shadow: 0 0 40px #ff0000;
  }
  100% {
    background-color: #b20000;
    -moz-box-shadow: 0 0 3px #b20000;
  }
}

@-o-keyframes glowing {
  0% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    box-shadow: 0 0 40px #ff0000;
  }
  100% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
}

@keyframes glowing {
  0% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    box-shadow: 0 0 40px #ff0000;
  }
  100% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
}

</style>
